<!-- <!DOCTYPE html>
<html lang="en"> -->

<!-- <head> -->
<title>Inicio de sesion</title>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
<!--===============================================================================================-->
<!-- <link href="./assets/login/images/favicon.png" rel="icon"> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/vendor/bootstrap/css/bootstrap.min.css" /> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/css/icons.css" /> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/css/main.css" /> -->
<!--===============================================================================================-->
<!-- </head> -->

<!-- <body style="background-color: #999999;"> -->

<div class="limiter fadeInDown">
    <div class="container-login100">
        <div class="login100-more" style="background-image: url(&#39;./assets/login/images/bg-01.jpg&#39;);"></div>

        <div class="wrap-login100 p-l-50 p-r-50 p-t-72 p-b-50 m-login__wrapper">
            <div class="m-login__logo">
                <a href="#"><img src="./assets/login/images/logotipo.png" /></a>
            </div>

            <form [formGroup]="changeForm" (ngSubmit)="onSubmit()" class="login100-form validate-form" autocomplete="on" validate="off">
                <span class="login100-form-title p-b-59">Solicitar Cambio de Contraseña</span>

                <div class="col-md-12 col-sm-12 form-group input-group">
                    <label for="documento">Número Documento</label>
                    <input type="text" id="documento" class="form-control" formControlName="documento" name="documento" placeholder="Digite su número de documento">
                </div>

                <div class="col-md-12 col-sm-12 form-group input-group">
                    <label for="email">Correo Electrónico</label>
                    <input type="text" id="email" class="form-control" formControlName="email" name="email" placeholder="Digite su correo electrónico">
                </div>

                <div class="col-md-12 col-sm-12 mt-10">
                    <input type="submit" [disabled]="!changeForm.valid" class="boton_personalizado" value="Enviar email">
                </div>

            </form>
            <div class="col m--align-left copyright">
                ©2018 Willis Towers Watson. Todos los Derechos Reservados.
            </div>
        </div>
    </div>
</div>


<script src="./assets/login/vendor/jquery/jquery-3.2.1.min.js"></script>
<!--===============================================================================================-->

<script src="./assets/login/vendor/bootstrap/js/popper.js"></script>
<script src="./assets/login/vendor/bootstrap/js/bootstrap.min.js"></script>
<!--===============================================================================================-->
<script src="./assets/login/js/main.js"></script>
<script src="https://www.google.com/recaptcha/api.js?render=6LeDDyYqAAAAAJQHoSdZI8BRXax9ye84bh9xKGrd"></script>